
import { useWebSocket } from 'context/WebSocketContext';
import { TablePaginationActions } from 'examples/Tables/CustomPaginationTable';
import DataTable from 'examples/Tables/DataTable';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import crudsService from 'services/cruds-service';

function JobsTable(props) {

    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState([])

    const { jobState } = useWebSocket();

    async function fetchJobs(page, size) {
        try {
            setLoader(true)
            let resp = await crudsService.getJobList({
                device_id: props.id, 
                offset: page - 1, 
                limit: size
            })

            if (resp?.total) {
                let params = props.getRows(resp.jobs)
                setData(params)
                const { total } = resp;
                setTotal(total)
            }

        } catch (error) {
            console.error('fetchMonitorLogs', error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {

        if(jobState && jobState?.device_id == props.id){
            // Check first id exist or not
            const job_id = jobState.job_id;
            const isExist = data.find((e) => e.id === job_id);

            if(isExist){
                setData((prev) => 
                    prev.map((item) => item.id === job_id ? { ...item, ...jobState } : item)
                );
            } else {
                let params = {
                    ...jobState,
                    "total_duration_seconds": 0,
                }
                setData((prev) => [params, ...prev])
            }
        }

    }, [jobState])

    async function onPageChange(e, page) {
        e.stopPropagation();
        setPage(page)
    }

    async function onRowsPerPageChange(e, value) {
        e.stopPropagation();
        setPageSize(value)
    }

    const removeEvents = async (e) => {
        try {
            if (!confirm('Are you sure you want to delete this event?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                setLoader(true)
                await crudsService.removeDeviceMultipleEvent(selectedEvent);
                toast.success('The Events has been successfully deleted')
                setSelectedEvent([])
                await fetchJobs(page, pageSize)
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('error')) {
                toast.error(err.error)
            }
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (page > 0) {
            fetchJobs(page, pageSize)
        }
    }, [page, pageSize])

    return (
        <>
            <DataTable
                table={{
                    columns: props.columns,
                    rows: data
                }}
                loader={loader}
                entriesPerPage={{ defaultValue: pageSize }}
                canPagination={false}
                selectedRows={selectedEvent}
                setSelectedRows={setSelectedEvent}
                deleteFunc={(e) => removeEvents(e)}
                {...props}
            />
            {
                total > pageSize &&
                <TablePaginationActions count={total} page={page} rowsPerPage={pageSize} onPageChange={onPageChange} onRowsPerPageChange={onRowsPerPageChange} />
            }
        </>
    )
}

export default JobsTable